<div mat-dialog-content>
    <p>You have reached the max allowed number for mobile phones/voice phones/emails</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
